(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nx-anelo-hero"] && !Shopify.designMode) return;
  try {
    
  if ('customElements' in window && !customElements.get('nx-anelo-scene')) {
    customElements.define('nx-anelo-scene', class extends HTMLElement {
      connectedCallback() {
        if (this._initialized || this._done) return;
        this._initialized = true;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (window.Shopify?.designMode || this._motion.matches || navigator.connection?.saveData || !('IntersectionObserver' in window)) return;
        this._image = this.querySelector('.nx-anelo-scene__image');
        if (!this._image) return;
        this._onMotion = () => { if (this._motion.matches) this._finish(); };
        this._onFocus = () => this._finish();
        this._onLoad = () => { if (this._visible) this._reveal(); };
        this._onError = () => this._finish();
        this._motion.addEventListener('change', this._onMotion);
        this.addEventListener('focusin', this._onFocus);
        this._image.addEventListener('load', this._onLoad);
        this._image.addEventListener('error', this._onError);
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries.some(entry => entry.isIntersecting);
          if (this._visible && this._image.complete && this._image.naturalWidth > 0) this._reveal();
        }, { threshold: .12, rootMargin: '0px 0px -5% 0px' });
        this._observer.observe(this);
      }
      _reveal() {
        if (this._done || this._running || !this.isConnected) return;
        this._running = true;
        this._observer?.disconnect();
        this.classList.add('is-revealing');
        this._timer = window.setTimeout(() => this._finish(), 1400);
      }
      _finish() {
        this._done = true;
        window.clearTimeout(this._timer);
        this._observer?.disconnect();
        this.classList.remove('is-revealing');
        this._motion?.removeEventListener('change', this._onMotion);
        this.removeEventListener('focusin', this._onFocus);
        this._image?.removeEventListener('load', this._onLoad);
        this._image?.removeEventListener('error', this._onError);
      }
      disconnectedCallback() { this._finish(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-header"]) return;
  try {
    
document.addEventListener('click', event => {
  if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const link = event.target.closest('a[data-nx-travel-link]');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
  const target = document.getElementById(destination.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  const menu = link.closest('dialog');
  if (menu?.open) menu.close();
  const fallback = link.closest('.nx-menu-fallback');
  if (fallback) fallback.open = false;
  window.location.hash = destination.hash;
  target.focus({preventScroll:true});
  target.scrollIntoView({block:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  function linkDiscovery() {
    const target = document.getElementById('nx-discovery');
    document.querySelectorAll('[data-nx-discovery-link]').forEach(link => {
      if (!link.dataset.discoveryFallback) link.dataset.discoveryFallback = link.getAttribute('href');
      link.setAttribute('href', target ? '#nx-discovery' : link.dataset.discoveryFallback);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkDiscovery, { once: true });
  else linkDiscovery();
  document.addEventListener('shopify:section:load', linkDiscovery);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(linkDiscovery));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-home-lineup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const sections = document.querySelectorAll('[data-nx-lineup]');
  if (!sections.length) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
  sections.forEach(section => {
    section.classList.add('nx-lineup--js');
    section.querySelectorAll('.nx-lineup__reveal').forEach(element => observer.observe(element));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-home-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  const sections = document.querySelectorAll('[data-nx-story]');
  if (!sections.length) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  sections.forEach(section => {
    section.classList.add('nx-story--js');
    section.querySelectorAll('.nx-story__reveal').forEach(element => observer.observe(element));
  });
})();

  } catch(e) { console.error(e); }
})();
})();
